// extracted by mini-css-extract-plugin
export var dividerLine = "_ai-3";
export var itemImage = "_ai-9";
export var lightDivider = "_ai-4";
export var modalContent = "_ai-5";
export var modalContentCompact = "_ai-6";
export var productCard = "_ai-a";
export var productImage = "_ai-b";
export var productImageCompact = "_ai-7";
export var productImagePlaceholder = "_ai-c";
export var productImagePlaceholderCompact = "_ai-8";
export var progressBarBackground = "_ai-1";
export var progressBarContainer = "_ai-0";
export var progressBarFill = "_ai-2";